/*
 * @Author: 赵泽文
 * @Date: 2022-03-07 16:36:38
 * @LastEditors: 赵泽文
 * @LastEditTime: 2023-12-29 15:46:50
 * @Description: 要货单数据存储
 */

import type {
  IEarthLocationReplenishmentModel,
  IEarthLocationReplenishmentStore,
} from '@monorepo/types/earthOrders/locationReplenishment/locationReplenishment.types';

import { getToday } from '@monorepo/utils';
import { tableUpdate } from '@monorepo/utils';
// import moment from 'moment';

const initState: IEarthLocationReplenishmentStore = {
  isInit: true,
  tableList: [],
  total: 0,
  query: {
    pageSize: 50,
    page: 1,
    date_from: '',
    date_to: '',
    date: getToday(),
    date_type: '制单时间',
  },
  auditNo: '',
  // auditProductList: [],
};

const earthLocationReplenishmentStore: IEarthLocationReplenishmentModel = {
  namespace: 'earthLocationReplenishmentStore',
  state: initState,
  reducers: {
    save(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
    updateTableList(state, { payload }) {
      const tableList = tableUpdate(state.tableList, payload.data, payload.auditNo);
      return {
        ...state,
        tableList,
      };
    },
    resetInit() {
      return { ...initState };
    },
  },
};

export default earthLocationReplenishmentStore;
